<template>
  <v-container>
    <v-card v-if="selectedDashboard.exportWinnerList">
      <v-layout column>
        <v-flex style>
          <v-row class="optionsBox">
            <v-col v-if="getCampaignId">
              <v-autocomplete
                v-model="selectedCampaignId"
                :items="selectableCampaigns"
                item-text="text"
                item-value="symbol"
                label="Select Campaign Id"
              >
              </v-autocomplete>
            </v-col>
            <v-col v-if="selectedCampaignId != ''">
              <v-autocomplete
                v-model="raffleType"
                :items="raffleTypes"
                item-text="name"
                item-value="value"
                label="Select Raffle Type"
              >
              </v-autocomplete>
            </v-col>
            <v-col class="dropdown" v-if="retailers && raffleType != 'all'">
              <v-autocomplete
                v-model="selectedRetailer"
                :items="retailers"
                item-text="name"
                item-value="id"
                label="Select Retailer"
                required
              >
              </v-autocomplete>
            </v-col>
            <v-col v-if="raffleType != 'all'">
              <v-checkbox
                v-model="dateFilter"
                label="Filter by date"
              ></v-checkbox>
              <date-picker
                required
                v-if="dateFilter"
                icon="mdi-calendar"
                label="Start Date"
                v-model="startDate"
                writable
              ></date-picker>
              <date-picker
                required
                v-if="dateFilter"
                icon="mdi-calendar"
                label="End Date"
                v-model="endDate"
                writable
              ></date-picker>
            </v-col>
            <v-col>
              <v-row>
                <v-btn
                  class="button"
                  color="blue darken-2"
                  @click="getWinnerList()"
                  :disabled="
                    !raffleType || (raffleType != 'all' && !selectedRetailer)
                  "
                  >Search
                </v-btn>
                </v-row>
                <v-row style="padding-top: 15px" v-if="hasData">
                <vue-excel-xlsx
                  :data="winnerList"
                  :columns="headers"
                  :filename="'WinnerList'"
                  :sheetname="'winners'"
                >
                <v-btn
                  class="button"
                  color="green darken-2"
                  @click="getWinnerList()"
                  >Download
                </v-btn>
                </vue-excel-xlsx>
              </v-row>
            </v-col>
          </v-row>
          <v-data-table
            dense
            :headers="headers"
            :items="winnerList"
            item-key="name"
            class="elevation-1"
          ></v-data-table>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import DatePicker from "../components/DatePicker.vue";

export default {
  components: {
    DatePicker
  },
  data () {
    return {
      headers: [],
      raffleTypes: [],
      winnerList: [],
      isLoading: true,
      dateFilter: true,
      startDate: moment().subtract(1, "days"),
      endDate: moment(),
      selectableCampaigns: [],
      selectedCampaignId: "",
      raffleType: "all",
      selectedRetailer: "",
      hasData: false,
      retailers: []
    };
  },
  computed: {
    ...mapGetters(["userToken", "selectedDashboard"]),
    getCampaignId: {
      get() {
        if (this.selectedDashboard.campaignId === "pg-template") {
          this.selectableCampaigns = [];
        } else if (this.selectedDashboard.campaignId === "pg-ro") {
          this.selectableCampaigns = [
            { text: "pg-charity-ro", value: "pg-charity-ro" }
          ];
          this.raffleTypes = [
            {
              name: "All Winners",
              value: "all"
            },
            {
              name: "Daily Raffle",
              value: "daily"
            },
            {
              name: "Weekly Raffle",
              value: "weekly"
            },
            {
              name: "Final Raffle",
              value: "final"
            }
          ];
        } else if (this.selectedDashboard.campaignId === "pg-turkey") {
          this.selectableCampaigns = [];
        } else if (this.selectedDashboard.campaignId === "FB-BOT") {
          this.selectableCampaigns = [{ text: "tuc-bot-ro", value: "TUC BOT" }];
          this.selectedCampaignId = "tuc-bot-ro";
          this.raffleTypes = [
            {
              name: "All Winners",
              value: "all"
            },
            {
              name: "Daily Raffle",
              value: "daily"
            }
          ];
        }
        return true;
      }
    }
  },
  created () {
    axios.get(`${this.selectedDashboard.endPoints.base}/getRetailers/${this.userToken}`)
      .then((response) => {
        if (response.data.response) {
          this.retailers = response.data.retailers;
        } else {
          this.retailers = [];
        }
      })
      .catch((er) => {
        this.errorHandler(er.response)
      });
  },
  methods: {
    ...mapActions(['errorHandler']),
    getWinnerList() {
      const method = "post";
      const url = `${this.selectedDashboard.endPoints.base}/getWinnerUsers`;

      const data = {
        sessid: this.userToken,
        campaignId: this.selectedCampaignId,
        startDate: this.startDate,
        dateFilter: this.dateFilter,
        endDate: this.endDate,
        retailer: this.selectedRetailer,
        raffleType: this.raffleType
      };
      axios({ method, url, data })
        .then((response) => {
          if (response.data.response) {
            this.winnerList = response.data.winnerList;
            this.headers = response.data.headers;
            this.isLoading = false;
            this.hasData = true
          } else {
            this.errorHandler(response.data.message || response.data.error)
          }
        })
        .catch((er) => {
          this.errorHandler(er.response)
        });
      return true;
    },
    formattedDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    }
  },
  mounted() {
    if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
  }
};
</script>

<style scoped>
.optionsBox {
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 25px;
}
</style>
